import { BaseEntity } from '../../../../../models';

export class ClienteECommerce implements BaseEntity {
    readonly id: number;
    idCliente: number;
    tipo: number;
    nome: string;
    url: string;
}
